import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isZapierIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return (
    code.includes('zapier') ||
    name.includes('zapier') ||
    description.includes('zapier')
  );
};

export const zapierProviderUiModule: McpProviderUiModule = {
  providerCode: 'zapier',
  matches: (integration: ManagedMcpIntegration) => isZapierIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'zapier',
    displayName: 'Zapier',
    supportsDynamicClientRegistration: false,
    requireClientId: false,
    requireClientSecret: false,
    showEndpointOverride: false,
    extraAuthFields: [
      {
        key: 'webhookUrl',
        label: 'Zapier Webhook URL',
        placeholder: 'https://hooks.zapier.com/hooks/catch/...',
        helperText: 'Paste the catch webhook URL from your Zapier Zap (Webhooks by Zapier → Catch Hook).',
        type: 'text' as const,
      },
    ],
  }),
};
